export default "__VITE_ASSET__294ef6e7__"